import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { UserMenuProvider } from './contexts/menuUser';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UserMenuProvider>
      <App /> 
    </UserMenuProvider>
  </React.StrictMode>
);


